import React from 'react';
import reading from '../data/reading';

const byDate = (a, b) => {
  if (!a.publishedDate && !b.publishedDate) return 0;
  if (!a.publishedDate) return 1;
  if (!b.publishedDate) return -1;
  return b.publishedDate.localeCompare(a.publishedDate);
};

const EntryList = ({ entries }) => {
  if (entries.length === 0) {
    return <p className="reading-empty">Nothing here yet.</p>;
  }
  return (
    <div className="reading-list">
      {entries.map((entry, i) => (
        <a
          key={i}
          href={entry.url}
          target="_blank"
          rel="noopener noreferrer"
          className="reading-entry"
        >
          {entry.image && (
            <div className="reading-image">
              <img src={entry.image} alt="" />
            </div>
          )}
          <div className="reading-content">
            <h3 className="reading-title">{entry.title}</h3>
            <p className="reading-meta">
              {[entry.author, entry.source].filter(Boolean).join(' · ')}
            </p>
            {entry.description && (
              <p className="reading-description">{entry.description}</p>
            )}
          </div>
          {entry.publishedDate && (
            <span className="reading-date">{entry.publishedDate}</span>
          )}
        </a>
      ))}
    </div>
  );
};

const Posts = () => {
  const blogs = reading.filter(e => e.type === 'blog').sort(byDate);
  const papers = reading.filter(e => e.type === 'paper').sort(byDate);

  return (
    <div className="reading-section">
      <div className="reading-columns">
        <div className="reading-col">
          <h2 className="reading-col-header">Writing</h2>
          <EntryList entries={blogs} />
        </div>
        <div className="reading-col-divider" />
        <div className="reading-col">
          <h2 className="reading-col-header">Papers</h2>
          <EntryList entries={papers} />
        </div>
      </div>
    </div>
  );
};

export default Posts;
